import React, { useRef, useEffect } from 'react';
import { trackPageView } from '../utils/analytics';

// Affiche exportable (PNG) qui reprend le style du site (bleu marine, dégradés, stats, tarifs, WhatsApp)
const Poster = () => {
  const svgRef = useRef(null);

  useEffect(() => {
    trackPageView('/poster');
  }, []);

  const downloadPNG = async () => {
    const svg = svgRef.current;
    if (!svg) return;

    const serializer = new XMLSerializer();
    let source = serializer.serializeToString(svg);
    // Ajouter l'espace de noms si manquant
  if (!source.match(/^<svg[^>]+xmlns="http:\/\/www\.w3\.org\/2000\/svg"/)) {
      source = source.replace('<svg', '<svg xmlns="http://www.w3.org/2000/svg"');
    }
    // Police sans-serif par défaut
    source = source.replace('<svg', '<svg style="font-family: system-ui, -apple-system, Segoe UI, Roboto, Ubuntu, Cantarell, Noto Sans, Helvetica, Arial, sans-serif"');

    const svgBlob = new Blob([source], { type: 'image/svg+xml;charset=utf-8' });
    const url = URL.createObjectURL(svgBlob);

    const img = new Image();
    const canvas = document.createElement('canvas');
    const scale = 2; // meilleure résolution
    const width = 1080;
    const height = 1350;
    canvas.width = width * scale;
    canvas.height = height * scale;
    const ctx = canvas.getContext('2d');
    ctx.fillStyle = '#0a1f44';
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    img.onload = () => {
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
      URL.revokeObjectURL(url);
      const pngUrl = canvas.toDataURL('image/png');
    const a = document.createElement('a');
    a.setAttribute('href', pngUrl);
    a.setAttribute('download', 'affiche-webaura.png');
    a.style.display = 'none';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    };
    img.onerror = () => URL.revokeObjectURL(url);
    img.src = url;
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-slate-100 py-10 px-4">
      <div className="max-w-5xl mx-auto">
        <div className="flex items-center justify-between mb-6">
          <h1 className="text-2xl md:text-3xl font-bold text-[#0a1f44]">Affiche – WebAura</h1>
          <button
            onClick={downloadPNG}
            className="bg-gradient-to-r from-amber-500 to-orange-600 text-white px-5 py-3 rounded-xl font-semibold shadow-lg hover:from-amber-600 hover:to-orange-700 transition"
          >
            Télécharger l'affiche (PNG)
          </button>
        </div>

        {/* Aperçu */}
        <div className="bg-white shadow-2xl rounded-2xl p-4 border border-[#2c5282]/10">
          <div className="w-full overflow-auto">
            {/* SVG au format portrait (1080x1350) */}
            <svg ref={svgRef} width="100%" viewBox="0 0 1080 1350" xmlns="http://www.w3.org/2000/svg">
              {/* Fond dégradé */}
              <defs>
                <linearGradient id="bg" x1="0" y1="0" x2="1" y2="1">
                  <stop offset="0%" stopColor="#0a1f44" />
                  <stop offset="100%" stopColor="#1e3a5f" />
                </linearGradient>
                <linearGradient id="cta" x1="0" y1="0" x2="1" y2="0">
                  <stop offset="0%" stopColor="#f59e0b" />
                  <stop offset="100%" stopColor="#ea580c" />
                </linearGradient>
                {/* Dégradé du logo (identique au site) */}
                <linearGradient id="logoGrad" x1="0" y1="0" x2="1" y2="1">
                  <stop offset="0%" stopColor="#0a1f44" />
                  <stop offset="100%" stopColor="#1e3a5f" />
                </linearGradient>
              </defs>

              <rect x="0" y="0" width="1080" height="1350" fill="url(#bg)" />

              {/* Cercles décoratifs */}
              <circle cx="150" cy="160" r="140" fill="rgba(255,255,255,0.05)" />
              <circle cx="980" cy="280" r="100" fill="rgba(255,255,255,0.06)" />
              <circle cx="200" cy="1050" r="120" fill="rgba(255,255,255,0.04)" />

          

              {/* Titre */}
              <text x="540" y="170" textAnchor="middle" fontSize="64" fill="#ffffff" fontWeight="700">WebAura</text>
              <text x="540" y="225" textAnchor="middle" fontSize="28" fill="#cbd5e1">Booster votre Aura sur le Web</text>

              {/* Bloc services */}
              <g transform="translate(90,290)">
                <text x="0" y="0" fontSize="36" fill="#ffffff" fontWeight="700">Nos services</text>
                <g transform="translate(0,40)">
                  <rect x="0" y="0" width="900" height="190" rx="18" fill="rgba(255,255,255,0.08)" stroke="rgba(255,255,255,0.18)" />
                  <g transform="translate(24,50)">
                    <text x="0" y="0" fontSize="26" fill="#ffffff">🌐 Site vitrine</text>
                    <text x="0" y="44" fontSize="20" fill="#bfdbfe">Design moderne, responsive, SEO</text>
                  </g>
                  <g transform="translate(340,50)">
                    <text x="0" y="0" fontSize="26" fill="#ffffff">🛒 E-commerce</text>
                    <text x="0" y="44" fontSize="20" fill="#bfdbfe">Paiement en ligne, gestion produits</text>
                  </g>
                  <g transform="translate(680,50)">
                    <text x="0" y="0" fontSize="26" fill="#ffffff">📝 Blog</text>
                    <text x="0" y="44" fontSize="20" fill="#bfdbfe">Contenu optimisé & partage</text>
                  </g>
                </g>
              </g>

              {/* Stats */}
              <g transform="translate(90,540)">
                <text x="0" y="0" fontSize="36" fill="#ffffff" fontWeight="700">Nos chiffres</text>
                <g transform="translate(0,40)">
                  <rect x="0" y="0" width="900" height="150" rx="18" fill="rgba(255,255,255,0.08)" stroke="rgba(255,255,255,0.18)" />
                  <g transform="translate(40,95)">
                    <text x="0" y="0" fontSize="70" fill="#fbbf24" fontWeight="800">+55</text>
                    <text x="120" y="0" fontSize="28" fill="#e2e8f0" fontWeight="600">Projets réalisés</text>
                  </g>
                  <g transform="translate(520,95)">
                    <text x="0" y="0" fontSize="70" fill="#34d399" fontWeight="800">+30</text>
                    <text x="120" y="0" fontSize="28" fill="#e2e8f0" fontWeight="600">Clients satisfaits</text>
                  </g>
                </g>
              </g>

              {/* Tarifs */}
              <g transform="translate(90,760)">
                <text x="0" y="0" fontSize="36" fill="#ffffff" fontWeight="700">Nos tarifs</text>
                <g transform="translate(0,30)">
                  <rect x="0" y="0" width="900" height="220" rx="18" fill="rgba(255,255,255,0.08)" stroke="rgba(255,255,255,0.18)" />
                  <g transform="translate(36,50)">
                    <rect x="0" y="0" width="250" height="120" rx="16" fill="#ffffff" />
                    <text x="125" y="45" textAnchor="middle" fontSize="26" fill="#0a1f44" fontWeight="700">Vitrine</text>
                    <text x="125" y="85" textAnchor="middle" fontSize="30" fill="#0a1f44" fontWeight="800">195K FCFA</text>
                  </g>
                  <g transform="translate(325,50)">
                    <rect x="0" y="0" width="250" height="120" rx="16" fill="#ffffff" />
                    <text x="125" y="45" textAnchor="middle" fontSize="26" fill="#0a1f44" fontWeight="700">Blog</text>
                    <text x="125" y="85" textAnchor="middle" fontSize="30" fill="#0a1f44" fontWeight="800">245K FCFA</text>
                  </g>
                  <g transform="translate(614,50)">
                    <rect x="0" y="0" width="250" height="120" rx="16" fill="#ffffff" />
                    <text x="125" y="45" textAnchor="middle" fontSize="26" fill="#0a1f44" fontWeight="700">E‑commerce</text>
                    <text x="125" y="85" textAnchor="middle" fontSize="30" fill="#0a1f44" fontWeight="800">275K FCFA</text>
                  </g>
                </g>
              </g>

              {/* CTA contact */}
              <g transform="translate(90,1030)">
                <rect x="0" y="0" width="900" height="210" rx="20" fill="rgba(255,255,255,0.1)" stroke="rgba(255,255,255,0.2)" />
                <text x="450" y="60" textAnchor="middle" fontSize="34" fill="#ffffff" fontWeight="800">Prêt à démarrer ?</text>
                <g transform="translate(160,95)">
                  <rect x="0" y="0" width="330" height="70" rx="35" fill="url(#cta)" />
                  <text x="165" y="46" textAnchor="middle" fontSize="26" fill="#ffffff" fontWeight="700">WhatsApp: 77 931 78 65</text>
                </g>
                <g transform="translate(510,95)">
                  <rect x="0" y="0" width="330" height="70" rx="35" fill="#ffffff" />
                  <text x="165" y="46" textAnchor="middle" fontSize="24" fill="#0a1f44" fontWeight="800">contact@webaura.com</text>
                </g>
              </g>

              {/* Bas de page */}
              <text x="540" y="1310" textAnchor="middle" fontSize="18" fill="#cbd5e1">www.webaura.vercel.app • Qualité • Sécurité • Support</text>
            </svg>
          </div>
          <p className="text-xs text-gray-500 mt-3">Aperçu 1080×1350 px. Cliquez sur "Télécharger l'affiche (PNG)" pour exporter.</p>
        </div>
      </div>
    </div>
  );
};

export default Poster;
